<template>
  <div class="footer">
    <Brands :isWhite="isWhite" />
    <Copyright :isWhite="isWhite" />
  </div>
</template>

<script>
import Brands from './Brands'
import Copyright from './Copyright'

export default {
  name: 'Footer',
  components: {
    Brands,
    Copyright
  },
  props: {
    isWhite: Boolean
  }
}
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media (max-width: 639px) {
  .footer {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Footer.vue